import { Grid, Button, TextField, MenuItem, Checkbox, FormControlLabel } from "@material-ui/core";
// import EnhancedSchemaForm from "../components/schemaForm";

import * as React from "react";
import EnhancedMap, { Dot, MarkerType } from "./enhancedMap";
import { JSONSchema6 } from "json-schema";
import { ConfigData } from "src/config";
import { ISubmitEvent, WidgetProps } from "react-jsonschema-form";
import { withScriptjs } from "react-google-maps";
import { compose, withProps } from "recompose";
import StandaloneSearchBox from "react-google-maps/lib/components/places/StandaloneSearchBox";

import PlaceResult = google.maps.places.PlaceResult;
import LatLngBounds = google.maps.LatLngBounds;

interface PropsBranchForm {
    data?: any;
    schema: JSONSchema6;
    config: ConfigData;
    sendData: (e: ISubmitEvent<any>) => void;
    cancel: () => void;
}

interface StateBranchForm {
    name?: string;
    location: Dot;
    street1: string;
    street2: string;
    searchBounds?: LatLngBounds;
    refDir?: StandaloneSearchBox;
    companies: Array<{ id: number; name: string }>;
    selectedCompanyId: string;
    inicioVentana?: string;
    finVentana?: string;
    maxDistanceValidation: boolean;
    maxDistance: number;
    referenceId?: string;
    errors: {
        name?: string;
        company?: string;
        street1?: string;
        lat?: string;
        lng?: string;
    };
}

class BranchForm extends React.Component<PropsBranchForm, StateBranchForm> {
    constructor(props: any) {
        super(props);
        console.log("BranchForm props:", props);
        // Si hay empresa seleccionada, tomar su ubicación del store
        let initialLocation: Dot;
        if (this.props.data && this.props.data.location) {
            initialLocation = new Dot(this.props.data.location.lat, this.props.data.location.lng);
        } else if (this.props.data && this.props.data.company && this.props.data.company.location) {
            initialLocation = new Dot(this.props.data.company.location.lat, this.props.data.company.location.lng);
        } else if (this.props.config && this.props.config.maps && this.props.config.maps.startingLocation) {
            initialLocation = new Dot(this.props.config.maps.startingLocation.lat, this.props.config.maps.startingLocation.lng);
        } else {
            initialLocation = new Dot(-34.6037, -58.3816);
        }
        this.state = {
            name: this.props.data ? this.props.data.name : "",
            location: initialLocation,
            street1: this.props.data ? this.props.data.location.street1 : "",
            street2: this.props.data ? this.props.data.location.street2 : "",
            companies: [],
            selectedCompanyId: (this.props.data && this.props.data.company && this.props.data.company.id) ? String(this.props.data.company.id) : '',
            inicioVentana: this.props.data ? this.props.data.inicioVentana : "",
            finVentana: this.props.data ? this.props.data.finVentana : "",
            maxDistanceValidation: this.props.data ? this.props.data.maxDistanceValidation || false : false,
            maxDistance: this.props.data ? this.props.data.maxDistance || 0 : 0,
            errors: {}
        };

        this.transforErrors = this.transforErrors.bind(this);
        this.updatePlace = this.updatePlace.bind(this);
        this.updateDir = this.updateDir.bind(this);
        this.locationWidget = this.locationWidget.bind(this);
        this.directionWidget = this.directionWidget.bind(this);
    }

    validate(): boolean {
        const errors: any = {};
        if (!this.state.street1 || this.state.street1.trim() === "") { errors.street1 = "La dirección principal es obligatoria"; }
        if (!this.state.location.lat) { errors.lat = "La latitud es obligatoria"; }
        if (!this.state.location.lng) { errors.lng = "La longitud es obligatoria"; }
        if (!this.state.selectedCompanyId) { errors.company = "Debe seleccionar una empresa"; }
        // Validar nombre en alta y edición
        // if (!this.props.data && !this.props.data.name && (!this.state.street1 || this.state.street1.trim() === "")) {
        //     errors.name = "El nombre es obligatorio";
        // }
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    componentDidMount(): void {
        // Cambiamos el estilo del pac-container, responsable de las opciones de ruta sugeridas en street1
        window.requestAnimationFrame(() => {
            const pacContainers = document.getElementsByClassName('pac-container');
            if (pacContainers) {
                const lon = pacContainers.length;
                for (let i = 0; i < lon; i++) {
                    const estilo = pacContainers[i].getAttribute('style');
                    pacContainers[i].setAttribute('style', estilo!.substring(14) + 'display: initial !!important;z-index: 10000');
                }
            }
        });
        // Cargar empresas desde el API
        // @ts-ignore
        import('src/api/ApiProvider').then(({ getApi }) => {
            getApi().company().list().then((companies: any[]) => {
                console.log("=== DEBUG SELECCION EMPRESA ===");
                console.log("Companies loaded:", companies.length, companies.map(c => ({ id: c.id, name: c.name })));
                console.log("Props data:", this.props.data);
                console.log("Props data company:", this.props.data && this.props.data.company);

                let selectedCompanyId = '';

                // Buscar empresa en los datos de edición
                if (this.props.data && this.props.data.company) {
                    const dataCompany = this.props.data.company;
                    console.log("Data company:", dataCompany, "Type:", typeof dataCompany);
                    let companyIdToFind: number | null = null;

                    // Si company es un número directamente
                    if (typeof dataCompany === 'number') {
                        companyIdToFind = dataCompany;
                        console.log("Company is number:", companyIdToFind);
                    }
                    // Si company es un string con ID
                    else if (typeof dataCompany === 'string') {
                        companyIdToFind = Number(dataCompany);
                        console.log("Company is string, converted to number:", companyIdToFind);
                    }
                    // Si company es un objeto con id
                    else if (dataCompany && typeof dataCompany === 'object' && dataCompany.id) {
                        companyIdToFind = dataCompany.id;
                        console.log("Company is object with id:", companyIdToFind);
                    }

                    if (companyIdToFind !== null) {
                        console.log("Looking for company ID:", companyIdToFind);
                        const found = companies.find(c => {
                            console.log("Comparing:", c.id, "vs", companyIdToFind, "Equal?", Number(c.id) === Number(companyIdToFind));
                            return Number(c.id) === Number(companyIdToFind);
                        });
                        if (found) {
                            selectedCompanyId = String(found.id);
                            console.log("FOUND! Setting selectedCompanyId to:", selectedCompanyId);
                        } else {
                            console.log("NOT FOUND");
                        }
                    }
                } else {
                    console.log("No data or no company in data");
                }

                console.log("Final selectedCompanyId:", selectedCompanyId);
                console.log("=== END DEBUG ===");
                this.setState({ companies, selectedCompanyId });
            });
        });
    }

    transforErrors(errors: any) {
        let tempErrors: any[]
        tempErrors = [];
        errors.map((e: any, index: number) => {
            switch (e.property) {
                case ".company.name":
                    e.message = "Falta seleccionar una empresa";
                    const pos = errors.findIndex((x: any) => x.property === ".company.name");
                    if (pos !== -1 && pos === index) {
                        tempErrors.push(e)
                    }
                    break;
                default:
                    console.warn("Error no controlado: ", e);
                    tempErrors.push(e)
                    break;
            }
        });
        return tempErrors;
    }

    updatePlace(e: google.maps.MouseEvent | google.maps.IconMouseEvent) {
        // Obtenemos las nuevas coordenadas
        const loc = new Dot(e.latLng.lat(), e.latLng.lng());
        // Obtenemos la nueva dirección
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode({ location: loc }, (results: any, status: any) => {
            if (status === "OK") {
                const dir = results[0].formatted_address;
                // Actualizamos el state
                this.setState({
                    location: loc,
                    street1: dir.substring(0, dir.lastIndexOf(",", dir.indexOf(",") + 1)),
                    street2: dir.substring(dir.lastIndexOf(",", dir.indexOf(",") + 1) + 1)
                });
            }
        });

    }

    updateDir() {
        // Obtenemos las nuevas direcciones
        const places: PlaceResult[] = this.state.refDir!.getPlaces();

        if (places && places.length > 0) {
            const bounds = new google.maps.LatLngBounds();

            places.forEach((place: PlaceResult) => {
                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport)
                } else {
                    bounds.extend(place.geometry.location)
                }
            });

            const loc = new Dot(places[0].geometry.location.lat(), places[0].geometry.location.lng());
            const dir = places[0].formatted_address;
            this.setState({
                street1: dir.substring(0, dir.indexOf(",")),
                street2: dir.substring(dir.indexOf(",") + 1),
                location: loc,
                searchBounds: bounds
            });
        }
    }

    locationWidget(props: WidgetProps) {
        return (<div>
            <EnhancedMap
                zoom={12}
                directions={undefined}
                center={this.state.location}
                destiny={[{
                    location: this.state.location,
                    order: this.props.data ? this.props.data.location.number : ""
                }]}
                handleDragEnd={(marker: MarkerType, index?: number) => (e: google.maps.MouseEvent) => {
                    this.updatePlace(e);
                }}
                handleOnClick={this.updatePlace} />
        </div>);
    }

    directionWidget(props: WidgetProps) {
        return (<StandaloneSearchBox
            ref={(r: StandaloneSearchBox) => this.setState({ refDir: r })}
            onPlacesChanged={() => { this.updateDir(); }}
            bounds={this.state.searchBounds}
        >
            <input
                value={this.state.street1}
                onChange={(e: any) => this.setState({ street1: e.target.value }, () => { this.componentDidMount(); })}
                required={props.required}
                className="form-control"
                placeholder=""
                onBlur={() => this.updateDir()}
            />
        </StandaloneSearchBox>);
    }

    render() {
        const { data, cancel, sendData } = this.props;
        const branch = data || {};
        return (
            <div>
                <EnhancedMap
                    zoom={12}
                    directions={undefined}
                    center={this.state.location}
                    destiny={[{
                        location: this.state.location,
                        order: branch.location && branch.location.number ? branch.location.number : ""
                    }]}
                    handleDragEnd={(marker: MarkerType, index?: number) => (e: google.maps.MouseEvent) => {
                        this.updatePlace(e);
                    }}
                    handleOnClick={this.updatePlace}
                />
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        if (!this.validate()) { return; }
                        const selectedCompany = this.state.companies.find(c => c.id === Number(this.state.selectedCompanyId));
                        if (selectedCompany) {
                            branch.company = { id: selectedCompany.id, name: selectedCompany.name };
                        }
                        sendData({
                            formData: {
                                ...branch,
                                name: this.state.name, // fuerza el valor actualizado
                                location: {
                                    lat: this.state.location.lat,
                                    lng: this.state.location.lng,
                                    street1: this.state.street1,
                                    street2: this.state.street2
                                },
                                inicioVentana: this.state.inicioVentana,
                                finVentana: this.state.finVentana,
                                maxDistanceValidation: this.state.maxDistanceValidation,
                                maxDistance: this.state.maxDistance,
                                referenceId: this.state.referenceId
                            }
                        } as any);
                    }}
                >
                    <Grid container spacing={16}>
                        <Grid item xs={12} sm={6}>
                            <label>Nombre</label>
                            <TextField
                                fullWidth
                                required
                                value={this.state.name}
                                onChange={(e: React.ChangeEvent<{ value: unknown }>) => this.setState({ name: String(e.target.value) })}
                                error={!!this.state.errors.name}
                                helperText={this.state.errors.name}
                                margin="normal"
                                label="Nombre de la sucursal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label>Empresa</label>
                            <TextField
                                select
                                fullWidth
                                required
                                value={this.state.selectedCompanyId}
                                onChange={(e: React.ChangeEvent<{ value: unknown }>) => this.setState({ selectedCompanyId: String(e.target.value) })}
                                error={!!this.state.errors.company}
                                helperText={this.state.errors.company}
                                margin="normal"
                                label="Empresa"
                            >
                                <MenuItem value="">Seleccione una empresa</MenuItem>
                                {this.state.companies.map(company => (
                                    <MenuItem key={company.id} value={String(company.id)}>{company.name}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                value={this.state.street1 || ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ street1: e.target.value })}
                                error={!!this.state.errors.street1}
                                helperText={this.state.errors.street1}
                                margin="normal"
                                label="Dirección principal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                value={this.state.street2 || ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ street2: e.target.value })}
                                margin="normal"
                                label="Dirección secundaria"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                value={this.state.inicioVentana || ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ inicioVentana: e.target.value })}
                                margin="normal"
                                label="Inicio ventana de entrega (HH:mm)"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                value={this.state.finVentana || ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ finVentana: e.target.value })}
                                margin="normal"
                                label="Fin ventana de entrega (HH:mm)"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                value={this.state.referenceId || ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ referenceId: e.target.value })}
                                margin="normal"
                                label="ID de referencia Ping"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.maxDistanceValidation}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ maxDistanceValidation: e.target.checked })}
                                        color="primary"
                                    />
                                }
                                label="Habilitar distancia máxima del conductor con referencia al punto de entrega"
                            />
                        </Grid>

                        {this.state.maxDistanceValidation && (
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    value={this.state.maxDistance || ''}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ maxDistance: Number(e.target.value) })}
                                    margin="normal"
                                    label="Distancia máxima (metros)"
                                    inputProps={{ min: 0 }}
                                />
                            </Grid>
                        )}

                    </Grid>
                    <Grid container justify="space-around" style={{ marginTop: 24 }}>
                        <Grid item>
                            <Button variant="contained" onClick={cancel} style={{ marginLeft: 'auto' }}>
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" type="submit" style={{ marginLeft: 'auto' }}>
                                Aceptar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        );
    }
}

export default compose<any, PropsBranchForm>(withProps((props: PropsBranchForm) => {
    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    }
}), withScriptjs)(BranchForm);


// WEBPACK FOOTER //
// ./src/components/branchForm.tsx